var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76867 10.9298C5.76867 10.9298 5.7689 10.93 6.00002 10.5833C6.23114 10.93 6.23168 10.9296 6.23168 10.9296C6.09172 11.0229 5.90863 11.0231 5.76867 10.9298ZM5.76867 10.9298L6.00002 10.5833L6.23168 10.9296L6.23256 10.929L6.23534 10.9272L6.24489 10.9207L6.27937 10.897C6.30896 10.8765 6.35149 10.8467 6.4051 10.8079C6.51229 10.7305 6.66403 10.6175 6.84551 10.473C7.20779 10.1846 7.69193 9.7678 8.17749 9.25527C9.13156 8.24819 10.1667 6.79245 10.1667 5.16665C10.1667 4.06158 9.72768 3.00178 8.94628 2.22038C8.16489 1.43898 7.10508 1 6.00002 1C4.89496 1 3.83515 1.43898 3.05376 2.22038C2.27236 3.00178 1.83337 4.06158 1.83337 5.16665C1.83337 6.79245 2.86848 8.24819 3.82255 9.25527C4.30811 9.7678 4.79225 10.1846 5.15453 10.473C5.33601 10.6175 5.48775 10.7305 5.59493 10.8079C5.64855 10.8467 5.69108 10.8765 5.72067 10.897L5.75515 10.9207L5.7647 10.9272L5.76748 10.929L5.76867 10.9298ZM6.00002 3.49999C5.07955 3.49999 4.33336 4.24618 4.33336 5.16665C4.33336 6.08712 5.07955 6.8333 6.00002 6.8333C6.92049 6.8333 7.66668 6.08712 7.66668 5.16665C7.66668 4.24618 6.92049 3.49999 6.00002 3.49999Z",
    fill: "#EE6955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinRed);
export default __webpack_public_path__ + "static/media/mapPinRed.97d5d5b069228068fdcb86cd3c6a0926.svg";
export { ForwardRef as ReactComponent };